import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ACCOUNT } from "../../constants";


export const getModulList = createAsyncThunk(
    'modul/list',
    async (param, thunkAPI) => {
      const respone = await fetch(`${API_ACCOUNT}/api/modul/list`, {
        method: 'get',
        headers: new Headers({
          Authorization: 'Bearer ' + param.token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
        }),
      })
      const responeResult = await respone.json()
      // console.log("as")
      return responeResult
    },
  )